<template>
  <div class='main'>
    <div class='navContainer'>
      <div class='navTitle' @click='titleClick'>民生整车物流信息管理平台</div>
      <el-menu :default-active='pathActive' router background-color='rgba(72,89,158,0)'
               text-color='#fff'
               active-text-color='#fff' @select='selectMenu' mode='horizontal'>
        <el-menu-item index='/basicfile' v-has="'pc_basic_doc'">基础档案</el-menu-item>
        <el-menu-item index='/contract' v-has="'pc_business'">商务合规</el-menu-item>
        <el-menu-item index='/vehicle' v-has="'pc_vehicle_logistics'">整车物流</el-menu-item>
        <el-menu-item index='/settle' v-has="'pc_settlement_manage'">结算管理</el-menu-item>
        <el-menu-item index='/financial' v-has="'pc_finance_manage'">财务管理</el-menu-item>


        <!-- <el-menu-item index="" @click="logistics" >结算管理</el-menu-item>
        <el-menu-item index="" @click="logistics" v-has="'pc_finance_manage'">财务管理</el-menu-item> -->


        <el-menu-item index='/audit' v-if='auditMenu.length>0'>审核管理</el-menu-item>
        <el-menu-item index='/audit' v-else v-has="'pc_auditor_manage'">审核管理</el-menu-item>
        <!-- <el-menu-item index="/statistical/order" v-has="'pc_census_form'">统计报表</el-menu-item> -->
        <el-menu-item index='' @click='bigScreenDisplay' v-has="'pc_data_report'">大屏展示
        </el-menu-item>
        <!-- <el-menu-item index="/system" v-has="'pc_system_set'">系统设置</el-menu-item> -->
        <el-menu-item index='' @click='logistics'>金融物流</el-menu-item>
        <el-menu-item index='' @click='logistics2'>城市配送</el-menu-item>
      </el-menu>
      <div class='userContainer'>
        <!-- <span class="el-icon-download" style="color:#fff;cursor:pointer;padding-right:5px"></span> -->
        <!-- <span @click="commandClick" style="color:#fff;cursor:pointer;padding-right:10px;font-size:13px;text-decoration:underline;">下载</span> -->
        <el-badge :hidden='badgeHidden' is-dot class='item'>
          <i class='el-icon-message' style='color:#fff;cursor:pointer;' @click='messageClick' />
        </el-badge>
        <!-- <el-avatar size="medium" :src="circleUrl"/> -->
        <el-dropdown @command='handleCommand'>
        <span class='el-dropdown-link'>
          {{ uerName }}<i class='el-icon-arrow-down el-icon--right' />
        </span>
          <el-dropdown-menu slot='dropdown'>
            <el-dropdown-item command='1'>个人信息</el-dropdown-item>
            <el-dropdown-item command='2'>修改密码</el-dropdown-item>
            <el-dropdown-item command='3'>退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <router-view />
    <el-dialog title='修改密码' :visible.sync='changdePwd' width='500px' @close='dialogClose'>
      <div class='dialogContainer'>
        <el-form :model='form' ref='formRef' label-width='96px' :rules='rulesModify'>
          <el-form-item prop='pwd' label='原密码：'>
            <el-input
              :style="'width:200px'"
              v-model='form.pwd'
              placeholder='请输入原始密码'
              autocomplete='off'
              size='small'
              type='password'
            />
          </el-form-item>
          <el-form-item prop='newPwd' label='新密码：'>
            <el-input
              :style="'width:200px'"
              v-model='form.newPwd'
              placeholder='请输入新密码'
              autocomplete='off'
              size='small'
              type='password'
            />
          </el-form-item>
          <el-form-item prop='cofPwd' label='确认密码：'>
            <el-input
              :style="'width:200px'"
              v-model='form.cofPwd'
              placeholder='请再次输入新密码'
              autocomplete='off'
              size='small'
              type='password'
            />
          </el-form-item>
          <div class='form-btn'>
            <el-button @click='changePwdCof' type='primary' size='small'>确认</el-button>
            <el-button @click='dialogClose' size='small'>关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getSessionStore } from '@/config/mUtils';
  import { updatePassword } from '@/service/getData';
  import { applicationAreaInfo } from '@/service/getData';

  export default {
    name: 'layout',
    data() {
      let validatorPwd = (rule, value, callback) => {
        // let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        // let reg = /^{6,16}$/
        // if(!reg.test(value)) {
        if (value.length < 6 || value.length > 16) {
          callback(new Error('密码为长度为6-16位'));
        } else {
          callback();
        }
      };
      // 验证两次输入密码是否正确
      let ModifyPass = (rule, value, callback) => {
        // let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/
        // if (!reg.test(value)) {
        if (value.length < 6 || value.length > 16) {
          callback(new Error('密码为长度为6-16位'));
        } else if (value !== this.form.newPwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        pathActive: null,
        activeNum: 1,
        badgeHidden: false,
        uerName: getSessionStore('userName'),
        circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        changdePwd: false,
        form: {
          pwd: '',
          newPwd: '',
          cofPwd: '',
        },
        indexPath: 'basicfile',
        // 修改密码验证表单
        rulesModify: {
          pwd: [
            {
              required: true,
              message: '旧密码不能为空',
              trigger: 'blur',
            },
          ],
          newPwd: [
            {
              required: true,
              validator: validatorPwd,
              trigger: 'blur',
            },
          ],
          cofPwd: [
            {
              required: true,
              validator: ModifyPass,
              trigger: 'blur',
            },
          ],
        },
        auditMenu: [],
      };
    },
    computed: {},
    methods: {
      bigScreenDisplay() {
        window.open('https://mslogistics.cn/bigData/index.html', '_blank');
      },
      logistics() {
        this.$alert('暂未开放！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        })
          .then(async () => {

          })
          .catch(() => {
          });
      },
      logistics2() {
        this.$alert('暂未开放！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        })
          .then(async () => {

          })
          .catch(() => {
          });
      },
      // 修改密码
      async changePwdCof() {
        this.$refs.formRef.validate(async (valid) => {
          if (valid) {
            let obj = 'oldPwd=' + this.form.pwd + '&newPwd=' + this.form.newPwd;
            let res = await updatePassword(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.changdePwd = false;
            setTimeout(() => {
              this.$router.push({ path: '/login' });
            }, 1000);
          } else {
            return false;
          }
        });
      },
      // 关闭弹窗
      dialogClose() {
        this.$refs.formRef.resetFields();
        this.changdePwd = false;
      },
      titleClick() {
        this.$router.push({ path: '/home' });
      },
      messageClick() {
        this.$router.push({ path: '/message' });
      },
      selectMenu() {
        this.activeNum = 0;
      },
      handleCommand(val) {
        this.activeNum = val;
        if (val === '1') {
          this.$router.push({ path: '/user' });
        } else if (val === '2') {
          this.changdePwd = true;
        } else if (val === '3') {
          this.$confirm('是否要退出登录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              this.$router.push({ path: '/login' });
            })
            .catch(() => {
            });
        }
      },
      // 下载页面
      commandClick() {
        this.$router.push({ path: '/download' });
      },
      getFields(input, field) {
        var output = [];
        for (var i = 0; i < input.length; ++i) {
          output.push(input[i][field]);
        }
        return output;
      },
      async _getAreaList() {
        let res = await applicationAreaInfo();
        if (res.status === 0) {
          if (res.data) {
            setSessionStore('areaList', res.data);
          }
        } else {
          this.$message.error(res.message);
        }
      },

    },
    watch: {
      $route(to, from) {
        let newArray = to.path.split('/');
        let oldArray = from.path.split('/');
        if (newArray[1] === oldArray[1]) {

        } else {
          this.pathActive = this.$route.path;
        }
        // if (this.$route.path.indexOf('/',1) !== -1)
        //   this.pathActive=this.$route.path.slice(0,this.$route.path.indexOf('/',1))
      },
    },
    created() {
      // this._getAreaList();
      if (JSON.parse(getSessionStore('auditMenu'))) {
        this.auditMenu = this.getFields(JSON.parse(getSessionStore('auditMenu')).childList, 'title');
      }
    },
    mounted() {
      console.log(this.$route);
      this.pathActive = this.$route.path;
      // if (this.$route.path.indexOf('/',1) !== -1)
      //   this.pathActive=this.$route.path.slice(0,this.$route.path.indexOf('/',1))
    },

    beforeDestroy() {
    },
  };
</script>

<style lang='scss' scoped>
  .main {
    width: 100%;

    .navContainer {
      width: 100%;
      //background-color: #48599E;
      /*background: url(../assets/images/v2_qyno57.png) no-repeat;*/
      /*background-size: 100% 100%;*/
      background: #5d6dc3;
      background: linear-gradient(to top, #5d6dc3, #3c86d8);
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      margin-bottom: 5px;

      ::v-deep {
        .el-menu-item {
          transition: background-color .5s;
          background-color: rgba(72, 89, 158, 0) !important;
        }

        .el-menu-item.is-active {
          background: linear-gradient(to top, #5d6dc3, #3c86d8);
        }
      }

      .navTitle {
        font-size: 16px;
        color: #fff;
        margin-right: 10px;

        &:hover {
          cursor: pointer;
        }
      }

      .userContainer {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-left: auto;
        /*width:81px;*/
        width: fit-content;

        .item {
          margin-right: 10px;
        }

        ::v-deep {
          .el-badge__content {
            top: 5px !important;
            right: 5px !important;
          }
        }

        .el-dropdown-link {
          color: #fff;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    .dialogContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .form-btn {
      text-align: center;
      position: relative;
      top: 15px;
    }

    ::v-deep {
      .el-loading-mask {
        z-index: 1000;
      }

      .el-form-item__error {
        padding-top: 0px;
      }

      .el-badge__content {
        top: 5px !important;
        right: 5px !important;
      }

      .el-menu-item-group__title {
        padding: 0;
      }

      .el-dialog__title {
        font-weight: 700;
        font-size: 16px;
      }

      label.el-form-item__label {
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 10px;
      }

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
        text-align: center;
      }

      .el-dialog__title {
        color: #fff;
      }

      .el-dialog__headerbtn {
        top: 0px;
        height: 42px;
        line-height: 42px;
        right: 10px;
        font-size: 20px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
      }
    }
  }
</style>
